const Invoices = () => import('./Invoices.vue')
const InvoiceDetails = () => import('./InvoiceDetails.vue')

export default [
  {
    name: 'invoices',
    path: 'invoices',
    component: Invoices,
    meta: {
      access: ['org.finance.invoice.view']
    },
    children: [
      {
        name: 'invoice-edit',
        path: ':invoiceId/edit',
        components: {
          modal: InvoiceDetails
        },
        meta: {
          showModal: true,
          access: ['org.finance.invoice.emit']
        }
      },
      {
        name: 'invoice-details',
        path: ':invoiceId/view',
        components: {
          modal: InvoiceDetails
        },
        meta: {
          showModal: true,
          readOnly: true,
          access: ['org.finance.invoice.view']
        }
      },
      {
        name: 'invoice-new',
        path: 'new',
        components: {
          modal: InvoiceDetails
        },
        meta: {
          showModal: true,
          access: ['org.finance.invoice.emit']
        }
      }
    ]
  }
]
